import { useTranslation } from "react-i18next";
import { useProjectStoreContext } from "@/modules/projects/components/ProjectStoreContext";
import { useCallback, useMemo } from "react";
import { AdditionalResetItem } from "@/components/query-table/components/QueryTableSettingsMenuBarMenu";
import { QueryTable } from "@/components/query-table/QueryTable";
import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";

export const ProjectStoreResetMenuBarMenu = () => {
  const { t } = useTranslation();
  const { periodFilter } = useProjectStoreContext();
  const { options } = useDataTableSettings();

  const resetPeriodFilter = useCallback(() => {
    if (periodFilter.options.length > 0) {
      periodFilter.setFromDate(periodFilter.options[0]);
      periodFilter.setToDate(
        periodFilter.options[periodFilter.options.length - 1],
      );
    }
  }, [periodFilter]);

  const resetStoreGroupFilter = useCallback(() => {
    options.resetFilterById("store_group_id");
  }, [options]);

  const additionalResetItems: AdditionalResetItem[] = useMemo(
    () => [
      {
        label: t("listMenubar.reset.resetPeriodFilter"),
        onReset: resetPeriodFilter,
      },
      {
        label: t("listMenubar.reset.resetStoreGroupFilter"),
        onReset: resetStoreGroupFilter,
      },
    ],
    [t, resetPeriodFilter, resetStoreGroupFilter],
  );

  return (
    <QueryTable.Menubar.Settings additionalResetItems={additionalResetItems} />
  );
};
